import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["lat", "lon", "selector", "coordsHelper"]

    connect() {
        this.updateSelector()
    }

    selectLocation(event) {
        const option = event.target.selectedOptions[0]
        const lat = option.dataset.lat
        const lon = option.dataset.lon

        if (lat && lon) {
            this.latTarget.value = lat
            this.lonTarget.value = lon
            if (this.hasCoordsHelperTarget) this.coordsHelperTarget.style.display = 'none'
        } else {
            if (this.hasCoordsHelperTarget) this.coordsHelperTarget.style.display = 'grid'
        }
    }

    // Try to set the selector based on current values
    updateSelector() {
        const currentLat = parseFloat(this.latTarget.value).toFixed(4)
        const currentLon = parseFloat(this.lonTarget.value).toFixed(4)
        for (let option of this.selectorTarget.options) {
            if (option.dataset.lat && option.dataset.lon) {
                const optLat = parseFloat(option.dataset.lat).toFixed(4)
                const optLon = parseFloat(option.dataset.lon).toFixed(4)

                if (optLat === currentLat && optLon === currentLon) {
                    this.selectorTarget.value = option.value
                    return
                }
            }
        }
    }
}
